import { render } from "./GamesView.vue?vue&type=template&id=1ef7be85&scoped=true"
import script from "./GamesView.vue?vue&type=script&lang=js"
export * from "./GamesView.vue?vue&type=script&lang=js"

import "./GamesView.vue?vue&type=style&index=0&id=1ef7be85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef7be85"]])

export default __exports__